import React from 'react'
import './invoice.css'
import InvoiceComponent from '../../../utils/CommonFunctionality/Invoice/InvoiceFunction'
import Layout from '../Layout'
import DashboardHeader from '../DashboardHeader'

const Invoice = (props) => {
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    return (
        <Layout props={props}>
            {isVarifiedGfTheme ? (
                <InvoiceComponent props={props} />
            ) : (
                <>
                    <DashboardHeader />
                    <InvoiceComponent props={props} />
                </>
            )}
        </Layout>
    )
}

export default Invoice
